import { isString } from "radash";

type GridMinWidthSize =
  | 40
  | 44
  | 48
  | 52
  | 56
  | 60
  | 64
  | 72
  | 80
  | 88
  | 96
  | 104
  | 112
  | 128;

type TwSize =
  | GridMinWidthSize
  | "2xl"
  | "3xl"
  | "4xl"
  | "5xl"
  | "6xl"
  | "7xl"
  | "xl"
  | 12
  | 14
  | 16
  | 20
  | 24
  | 28
  | 32
  | 36;

type TwPx =
  | "300px"
  | "400px"
  | "500px"
  | "600px"
  | "700px"
  | "800px"
  | "900px"
  | "1000px"
  | "1100px"
  | "1200px"
  | "1300px"
  | "1400px";

type GridMinWidth = `${GridMinWidthSize}`;

function twSizeToPx(twSize: TwPx | TwSize): number {
  if (isString(twSize)) {
    if (twSize.endsWith("px")) return Number.parseInt(twSize);
    const sizeMap = {
      xl: 144,
      "2xl": 168,
      "3xl": 192,
      "4xl": 224,
      "5xl": 256,
      "6xl": 288,
      "7xl": 320,
    };
    return sizeMap[twSize as keyof typeof sizeMap] * 4;
  }
  return twSize * 4;
}

export type { GridMinWidth, GridMinWidthSize, TwPx, TwSize };
export { twSizeToPx };
